import VIDEO_TYPE from "enums/VIDEO_TYPE";

export enum FILE_TYPE {
  VIDEO = "VIDEO",
  CLIP = "CLIP",
  FILE = "FILE",
  IMAGE = "IMAGE",
  PDF = "PDF",
  UNKNOWN = "UNKNOWN",
}

export default interface VideoDto {
  createdById?: string;
  createdOn: number;
  id: string;
  description: string;
  duration: number;
  languageCode: string | null;
  numberOfSpeakers?: number;
  originalFilename: string;
  parentId?: string;
  participantId: string;
  participantIds: string[];
  participantFullName: string;
  inProgress: boolean;
  questionId: string;
  scriptId: string;
  skipped: boolean;
  thumbnail: string;
  title: string;
  transcodeFilename: string;
  transcription: string;
  type: VIDEO_TYPE | FILE_TYPE;
  userAgent: string;
}

export class VideoClass implements VideoDto {
  createdById?: string;
  createdOn: number;
  id: string;
  description: string;
  duration: number;
  languageCode: string | null;
  numberOfSpeakers?: number;
  originalFilename: string;
  parentId?: string;
  participantId: string;
  participantIds: string[];
  participantFullName: string;
  inProgress: boolean;
  questionId: string;
  scriptId: string;
  skipped: boolean;
  thumbnail: string;
  title: string;
  transcodeFilename: string;
  transcription: string;
  type: VIDEO_TYPE | FILE_TYPE;
  userAgent: string;

  constructor(data: Partial<VideoDto>) {
    Object.assign(this, data);
  }

  get canBeAddedToPlaylist(): boolean {
    if (this.type === FILE_TYPE.IMAGE) return true;
    if (this?.duration) return true;

    return false;
  }
}
